import * as React from 'react';
import styles from './Partner.module.css';

interface PartnerLogoProps {
    image: string;
    url?: string;
    onClick?: (e: React.MouseEvent) => void;
}

export const PartnerLogo: React.FC<PartnerLogoProps> = ({ image, onClick, url }) => {
    const handleClick = (e: React.MouseEvent) => {
        if (url) {
            window.open(url, '_blank');
        }
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <img
            className={styles.partnerLogo}
            src={image}
            onClick={handleClick}
            alt={'Logo of partner of the peepoSprint event'}
        />
    );
};